import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { TooltipDirectiveModule } from '@ux/directives/tooltip/tooltip-directive.module';
import { LuggageModule } from '@shared/luggage/luggage.module';
import { BusSummaryComponent } from '@shared/bus-itinerary/components/bus-summary/bus-summary.component';
import { BusDetailComponent } from '@shared/bus-itinerary/components/bus-detail/bus-detail.component';
import { BusInfoComponent } from '@shared/bus-itinerary/components/bus-info/bus-info.component';
import { FlightSegmentConnectionModule } from '@shared/flight-segment-connection/flight-segment-connection.module';
import {
  SimpleBusSummaryComponent
} from '@shared/bus-itinerary/components/simple-bus-summary/simple-bus-summary.component';
import {
  BusDesktopRouteChoiceComponent
} from '@shared/bus-itinerary/components/bus-desktop-route-choice/bus-desktop-route-choice.component';
import {
  BusDesktopRouteChoiceHeaderComponent
} from '@shared/bus-itinerary/components/bus-desktop-route-choice-header/bus-desktop-route-choice-header.component';
import {
  BusResultsMobileItineraryRouteDetailComponent
  // eslint-disable-next-line max-len
} from '@shared/bus-itinerary/components/bus-results-mobile-itinerary-route-detail/bus-results-mobile-itinerary-route-detail.component';
import {
  BusResultsMobileItineraryComponent
} from '@shared/bus-itinerary/components/bus-results-mobile-itinerary/bus-results-mobile-itinerary.component';
import {
  BusResulsMobilePlaceholderComponent
} from '@shared/bus-itinerary/components/bus-results-mobile-placeholder/bus-resuls-mobile-placeholder.component';
import { BusResultsSortComponent } from '@shared/bus-itinerary/components/bus-results-sort/bus-results-sort.component';
import { BusRouteDetailComponent } from '@shared/bus-itinerary/components/bus-route-detail/bus-route-detail.component';
import {
  BusResultsDesktopPlaceholderFiltersComponent
} from '@shared/bus-itinerary/components/placeholders/bus-desktop-placeholder-filters/bus-desktop-placeholder-filters.component';
import {
  BusResultsDesktopPlaceholderItineraryComponent
// eslint-disable-next-line max-len
} from '@shared/bus-itinerary/components/placeholders/bus-desktop-placeholder-itinerary/bus-desktop-placeholder-itinerary.component';
import {
  BusResultsDesktopPlaceholderSortComponent
} from '@shared/bus-itinerary/components/placeholders/bus-desktop-placeholder-sort/bus-desktop-placeholder-sort.component';
import {
  BusResultsMobilePlaceholderItineraryComponent
// eslint-disable-next-line max-len
} from '@shared/bus-itinerary/components/placeholders/bus-mobile-placeholder-itinerary/bus-mobile-placeholder-itinerary.component';
import {
  BusResultsMobilePlaceholderSortComponent
} from '@shared/bus-itinerary/components/placeholders/bus-mobile-placeholder-sort/bus-mobile-placeholder-sort.component';
import {
  BusResultsMobilePlaceholdersFiltersComponent
} from '@shared/bus-itinerary/components/placeholders/bus-mobile-placeholders-filters/bus-mobile-placeholders-filters.component';
import { TooltipModule } from '@shared/tooltip/tooltip.module';
import { BenefitsModule } from '@shared/benefits/benefits.module';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { PaymentDetailModule } from '@shared/payment-detail/payment-detail.module';

@NgModule({
  declarations: [
    SimpleBusSummaryComponent,
    BusSummaryComponent,
    BusDetailComponent,
    BusInfoComponent,
    BusDesktopRouteChoiceComponent,
    BusDesktopRouteChoiceHeaderComponent,
    BusResultsMobileItineraryComponent,
    BusResultsMobileItineraryRouteDetailComponent,
    BusRouteDetailComponent,
    BusResultsSortComponent,
    BusResulsMobilePlaceholderComponent,
    BusResultsMobilePlaceholderSortComponent,
    BusResultsMobilePlaceholderItineraryComponent,
    BusResultsMobilePlaceholdersFiltersComponent,
    BusResultsDesktopPlaceholderFiltersComponent,
    BusResultsDesktopPlaceholderSortComponent,
    BusResultsDesktopPlaceholderItineraryComponent,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    TooltipDirectiveModule,
    LuggageModule,
    FlightSegmentConnectionModule,
    TooltipModule,
    BenefitsModule,
    ButtonDsComponent,
    FixedSurfaceModule,
    PaymentDetailModule,
  ],
  exports: [
    SimpleBusSummaryComponent,
    BusSummaryComponent,
    BusDetailComponent,
    BusInfoComponent,
    BusDesktopRouteChoiceComponent,
    BusDesktopRouteChoiceHeaderComponent,
    BusResultsMobileItineraryComponent,
    BusResultsMobileItineraryRouteDetailComponent,
    BusRouteDetailComponent,
    BusResultsSortComponent,
    BusResulsMobilePlaceholderComponent,
    BusResultsMobilePlaceholderSortComponent,
    BusResultsMobilePlaceholderItineraryComponent,
    BusResultsMobilePlaceholdersFiltersComponent,
    BusResultsDesktopPlaceholderFiltersComponent,
    BusResultsDesktopPlaceholderSortComponent,
    BusResultsDesktopPlaceholderItineraryComponent,
  ]
})
export class BusItineraryModule { }
